import { IQuantityPerUnit } from '@alberta/konexi-shared';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ArticleUnitPipe2 } from '@common/pipes/article/article-unit.pipe2';
import { ArticleUnitPipe } from '@common/pipes/article/articleunit-pipe';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SelectionItem } from '../../models/selectionItem';
import { AlbertaIconModule } from '../alberta-icon/alberta-icon.module';
import { AlbertaInputsModule } from '../inputs/inputs-components.module';
import { SelectionService } from '../services/selection.service';

@Component({
  selector: 'itl-article-select-packaging-unit',
  template: `
    <itl-button class="button" (click)="openUnitSelect()">
      <itl-alberta-icon name="alberta-box" class="icon"></itl-alberta-icon>
      <span>{{ value | articleUnit }}</span>
    </itl-button>
  `,
  styles: [
    `
      .button {
        font-size: 14px;
        --button-padding: 7px 14px;
        --button-margin: 0;
        -webkit-user-select: none;
        -ms-user-select: none;
        user-select: none;

        .icon {
          margin-right: 5px;
          opacity: 0.5;
          zoom: 1.2;
        }
      }
    `,
  ],
  standalone: true,
  imports: [AlbertaInputsModule, TranslateModule, AlbertaIconModule, ArticleUnitPipe2],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArticleSelectPackagingUnitComponent implements OnInit {
  @Input() packagingUnits: IQuantityPerUnit[];
  @Input() value: IQuantityPerUnit;

  @Output() valueChange = new EventEmitter<IQuantityPerUnit>();

  private _selectionItems: SelectionItem[] = [];

  constructor(
    private _selectionService: SelectionService,
    private _translate: TranslateService,
    private _articleUnitPipe: ArticleUnitPipe,
    private _changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this._selectionItems = this.packagingUnits
      .filter(packagingUnit => !packagingUnit.archived)
      .map(packagingUnit => this.createPackagingUnitItem(packagingUnit));
  }

  async openUnitSelect() {
    const defaultPackagingUnit =
      this.packagingUnits.length === 1
        ? this.packagingUnits[0]
        : this.packagingUnits.find((item: any) => item.defaultPackagingUnit);
    const currentValue = this.value?._id || defaultPackagingUnit?._id || null;
    const result = await this._selectionService.openSelection(
      currentValue,
      this._selectionItems,
      this._translate.instant('order.edit.unitSelect')
    );
    if (!result.canceled) {
      const selectedPackagingUnit = this.packagingUnits.find(packagingUnit => packagingUnit._id === result.value);
      this.value = selectedPackagingUnit;
      this._changeDetectorRef.markForCheck();
      this.valueChange.emit(selectedPackagingUnit);
    }
  }

  private createPackagingUnitItem(packagingUnit: IQuantityPerUnit): SelectionItem {
    const stueck = this._translate.instant('article.edit.units.stk');
    return new SelectionItem(
      packagingUnit._id,
      `${this._articleUnitPipe.transform(packagingUnit.unit)} (${packagingUnit.quantity} ${stueck})`
    );
  }
}
